import { render, staticRenderFns } from "./NavbarMobile.vue?vue&type=template&id=2efb874e&scoped=true"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"
import style0 from "./NavbarMobile.vue?vue&type=style&index=0&id=2efb874e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb874e",
  null
  
)

export default component.exports